import moment from 'moment';

//Edad Númerica
export const calculateAge = (birthday) => {
    console.log(birthday);
    let hoy = new Date();
    let cumpleanos = new Date(birthday);
    let edad = hoy.getFullYear() - cumpleanos.getFullYear();
    let meses = hoy.getMonth() - cumpleanos.getMonth();
    if (meses < 0 || (meses === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edad--;
    }
    return edad;
}

//Edad Parseada
export const calculateAgeParse = (fechaUsuario) => {
    let d = new Date(),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    d=[year, month, day].join('-')
    var hoy = new Date(d);
    var cumpleanos = new Date(fechaUsuario);
    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
    var m = hoy.getMonth() - cumpleanos.getMonth();
    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edad--;
    }
    var meses=0;
    if(hoy.getMonth()>cumpleanos.getMonth()){
        meses=hoy.getMonth()-cumpleanos.getMonth();
    }else if(hoy.getMonth()<cumpleanos.getMonth()){
        meses=12-(cumpleanos.getMonth()-hoy.getMonth());
    }else if(hoy.getMonth()==cumpleanos.getMonth() && hoy.getDate()>cumpleanos.getDate() ){
        if(hoy.getMonth()-cumpleanos.getMonth()==0){
            meses=0;
        }else{
            meses=11;
        }    
    }
    let dias  = hoy.getDate() - cumpleanos.getDate();
    if(dias < 0) {
        meses = (meses - 1 < 0) ? 11 : meses - 1;
        dias = 30 + dias;
    }
    let edadTotal = `${edad} años ${meses} meses ${dias} días`;
    
    if(edad >= 0)
    {
        return edadTotal;
    }
    else
    {
        return "";
    }
}

export const concatenateNames = (namePatient,firstLastName,secondLastName) => {
    let completeName = namePatient;

    if(firstLastName != null && firstLastName != undefined && firstLastName != "")
    {
        completeName = completeName + " " + firstLastName; 
    }

    if(secondLastName != null && secondLastName != undefined && secondLastName != "")
    {
        completeName = completeName + " " + secondLastName;
    }

    return completeName;
}

export const splitNames = (str) => {
    var tokens = str.split(' ');
    // Arreglo donde se guardan las palabras del nombre.
    var names = [];
    // Palabras de apellidos compuestos
    const special_tokens = new Array('da', 'de', 'del', 'la', 'las', 'los', 'mac', 'mc', 'van', 'von', 'y', 'i', 'san', 'santa');
    var prev = "";

    tokens.forEach(token => {
        var _token = token.toLowerCase();
        if (special_tokens.includes(_token)) {
            prev = `${prev}${_token.toUpperCase()} `;
        } else {
            names.push(`${prev}${_token.toUpperCase()}`);
            prev = "";
        }
    });

    var num_nombres = names.length;

    var ape1 = "",
        ape2 = "";
    var apellidos = [];

    switch (num_nombres) {
        case 0:
            ape1 = '';
            break;
        case 1:
            ape1 = names[0];
            break;
        case 2:
            ape1 = names[0];
            ape2 = names[1];
            break;
        case 3:
            ape1 = names[0];
            ape2 = `${names[1]} ${names[2]}`;
            break;
        case 4:
            ape1 = `${names[0]} ${names[1]}`;
            ape2 = `${names[2]} ${names[3]}`;
            break;
        default:
            ape1 = `${names[0]} ${names[1]}`;
            names.splice(0, 2);
            ape2 = names.join(" ");
            break;
    }
    apellidos.push(ape1);
    apellidos.push(ape2);
    return apellidos;
}

export const getPatientsAllegies = (id_historia) => {
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias/listar?id_historia=' + id_historia, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Error consultando las alergias del paciente");
            }
        }).then((data) => {
            if (data.length > 0) {
                console.log("Alergias", data);
                resolve(data);
            }
            else
            {
                resolve(null);
            }
        }).catch(err => {
            console.log(err);
            resolve(null);
        });
    })
    
}